import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { PhoneIcon, MailIcon, CheckCircleIcon, MapPinIcon } from 'lucide-react';
import { useForm } from '@formspree/react';
export function ContactPage() {
  // Replace 'YOUR_FORM_ID' with your actual Formspree form ID
  // Get it from https://formspree.io after creating an account
  const [state, handleSubmit] = useForm('YOUR_FORM_ID');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await handleSubmit(e);
    if (state.succeeded) {
      setFormData({
        name: '',
        email: '',
        message: ''
      });
    }
  };
  return <div className="w-full" data-id="element-215">
      <Helmet data-id="element-216">
        <title data-id="element-217">
          Kontak - PT Jagat Indo Perkasa | Hubungi Kami +62 811-1477-977 |
          Ground Handling 24/7
        </title>
        <meta name="description" content="Hubungi PT Jagat Indo Perkasa untuk informasi dan konsultasi layanan ground handling profesional. Telepon: +62 811-1477-977 (24/7), Email: jagatindoperkasa1977@gmail.com. Kantor: Bandara Halim Perdanakusuma, Jakarta. Siap melayani kebutuhan ramp handling, passenger service, cargo handling, dan flight support Anda." data-id="element-218" />
        <meta name="keywords" content="kontak PT Jagat Indo Perkasa, hubungi ground handling Indonesia, telepon ground handling 24/7, email ground handling, alamat kantor Jakarta, konsultasi ground handling, customer service penerbangan, layanan ground handling 24 jam" data-id="element-219" />
        <meta name="author" content="PT Jagat Indo Perkasa" data-id="element-220" />
        <meta name="robots" content="index, follow" data-id="element-221" />
        <link rel="canonical" href="https://jagatindoperkasa.id/contact" data-id="element-222" />
        <meta name="geo.region" content="ID-JK" data-id="element-223" />
        <meta name="geo.placename" content="Jakarta" data-id="element-224" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" data-id="element-225" />
        <meta property="og:url" content="https://jagatindoperkasa.id/contact" data-id="element-226" />
        <meta property="og:site_name" content="PT Jagat Indo Perkasa" data-id="element-227" />
        <meta property="og:title" content="Kontak PT Jagat Indo Perkasa - Hubungi Kami 24/7" data-id="element-228" />
        <meta property="og:description" content="Hubungi kami untuk mendiskusikan kebutuhan ground handling Anda. Tersedia 24/7 untuk melayani Anda. Telepon: +62 811-1477-977" data-id="element-229" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png" data-id="element-230" />
        <meta property="og:locale" content="id_ID" data-id="element-231" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-232" />
        <meta name="twitter:url" content="https://jagatindoperkasa.id/contact" data-id="element-233" />
        <meta name="twitter:title" content="Kontak PT Jagat Indo Perkasa" data-id="element-234" />
        <meta name="twitter:description" content="Hubungi kami 24/7 untuk layanan ground handling profesional. Telepon: +62 811-1477-977" data-id="element-235" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png" data-id="element-236" />
        <script type="application/ld+json" data-id="element-237">
          {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'ContactPage',
          '@id': 'https://jagatindoperkasa.id/contact#contactpage',
          url: 'https://jagatindoperkasa.id/contact',
          name: 'Kontak PT Jagat Indo Perkasa',
          description: 'Halaman kontak untuk menghubungi PT Jagat Indo Perkasa',
          mainEntity: {
            '@type': 'Organization',
            '@id': 'https://jagatindoperkasa.id/#organization',
            name: 'PT Jagat Indo Perkasa',
            telephone: '+62-811-1477-977',
            email: 'jagatindoperkasa1977@gmail.com',
            address: {
              '@type': 'PostalAddress',
              streetAddress: 'Bandara Halim Perdanakusuma, Sisi Airside No. 77A',
              addressLocality: 'Jakarta',
              addressRegion: 'DKI Jakarta',
              addressCountry: 'ID'
            },
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '+62-811-1477-977',
              contactType: 'Customer Service',
              availableLanguage: ['Indonesian', 'English'],
              hoursAvailable: {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
                opens: '00:00',
                closes: '23:59'
              },
              areaServed: 'ID'
            }
          }
        })}
        </script>
        <script type="application/ld+json" data-id="element-238">
          {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          '@id': 'https://jagatindoperkasa.id/#localbusiness',
          name: 'PT Jagat Indo Perkasa',
          image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png',
          telephone: '+62-811-1477-977',
          email: 'jagatindoperkasa1977@gmail.com',
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Bandara Halim Perdanakusuma, Sisi Airside No. 77A',
            addressLocality: 'Jakarta',
            addressRegion: 'DKI Jakarta',
            addressCountry: 'ID'
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: '-6.2665',
            longitude: '106.8914'
          },
          openingHoursSpecification: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
            opens: '00:00',
            closes: '23:59'
          },
          priceRange: '$$'
        })}
        </script>
      </Helmet>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-sky-500 to-blue-700 text-white py-16" data-id="element-239">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-240">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-241">Kontak</h1>
          <p className="text-xl text-sky-100" data-id="element-242">
            Hubungi kami untuk informasi lebih lanjut tentang layanan ground
            handling kami
          </p>
        </div>
      </section>
      {/* Contact Content */}
      <section className="py-16 bg-white" data-id="element-243">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-245">
            <div className="bg-white shadow-lg rounded-xl p-8" data-id="element-246">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-247">
                Informasi Kontak
              </h2>
              <div className="space-y-6" data-id="element-248">
                <div className="flex items-start space-x-4" data-id="element-249">
                  <div className="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-250">
                    <MapPinIcon className="w-6 h-6 text-sky-600" data-id="element-251" />
                  </div>
                  <div data-id="element-252">
                    <div className="font-semibold text-gray-900 mb-1" data-id="element-253">
                      Alamat Kantor
                    </div>
                    <p className="text-gray-700" data-id="element-254">
                      PT. JAGAT INDO PERKASA
                      <br data-id="element-255" />
                      Bandara Halim Perdanakusuma
                      <br data-id="element-256" />
                      Sisi Airside No. 77A
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4" data-id="element-257">
                  <div className="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-258">
                    <PhoneIcon className="w-6 h-6 text-sky-600" data-id="element-259" />
                  </div>
                  <div data-id="element-260">
                    <div className="font-semibold text-gray-900 mb-1" data-id="element-261">
                      Telepon
                    </div>
                    <a href="tel:+6281114477977" className="text-sky-600 hover:text-sky-700" data-id="element-262">
                      +62 811-1477-977
                    </a>
                    <p className="text-sm text-gray-600 mt-1" data-id="element-263">Tersedia 24/7</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4" data-id="element-264">
                  <div className="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-265">
                    <MailIcon className="w-6 h-6 text-sky-600" data-id="element-266" />
                  </div>
                  <div data-id="element-267">
                    <div className="font-semibold text-gray-900 mb-1" data-id="element-268">
                      Email
                    </div>
                    <a href="mailto:jagatindoperkasa1977@gmail.com" className="text-sky-600 hover:text-sky-700" data-id="element-269">
                      jagatindoperkasa1977@gmail.com
                    </a>
                    <p className="text-sm text-gray-600 mt-1" data-id="element-270">
                      Respons dalam 24 jam
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-br from-sky-50 to-blue-50 shadow-lg rounded-xl p-8" data-id="element-271">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-272">
                Kirim Pesan
              </h2>
              {state.succeeded && <div className="mb-6 bg-green-50 border border-green-200 rounded-lg p-4 flex items-start space-x-3" data-id="element-273">
                  <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-274" />
                  <div data-id="element-275">
                    <p className="text-green-800 font-medium" data-id="element-276">
                      Pesan berhasil dikirim!
                    </p>
                    <p className="text-green-700 text-sm mt-1" data-id="element-277">
                      Terima kasih telah menghubungi kami. Kami akan merespons
                      dalam 24 jam.
                    </p>
                  </div>
                </div>}
              <form onSubmit={onSubmit} className="space-y-4" data-id="element-278">
                <div data-id="element-279">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-280">
                    Nama
                  </label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500" placeholder="Nama lengkap Anda" data-id="element-281" />
                </div>
                <div data-id="element-282">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-283">
                    Email
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500" placeholder="email@contoh.com" data-id="element-284" />
                </div>
                <div data-id="element-285">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-286">
                    Pesan
                  </label>
                  <textarea id="message" name="message" rows={4} value={formData.message} onChange={handleInputChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500" placeholder="Tulis pesan Anda di sini..." data-id="element-287"></textarea>
                </div>
                <button type="submit" disabled={state.submitting} className="w-full bg-sky-500 text-white py-3 px-6 rounded-lg font-semibold hover:bg-sky-600 transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none" data-id="element-288">
                  {state.submitting ? 'Mengirim...' : 'Kirim Pesan'}
                </button>
                {state.errors && state.errors.length > 0 && <div className="mt-4 bg-red-50 border border-red-200 rounded-lg p-4" data-id="element-289">
                    <p className="text-red-800 text-sm" data-id="element-290">
                      Terjadi kesalahan saat mengirim pesan. Silakan coba lagi.
                    </p>
                  </div>}
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>;
}